import { createApi } from '@reduxjs/toolkit/query/react';
import AuthorizationManager, {
  PostLoginDataInterface,
  PostOptDataInterface,
} from '../../services/auth/AuthorizationManager';
import { IMap, OneTimePasswordInterface } from '../../services/exports/Interfaces';
import { fakeBaseQuery } from '@reduxjs/toolkit/dist/query/react';

export const authApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'authApiSlice',
  endpoints: (build) => ({
    login: build.mutation<unknown, PostLoginDataInterface>({
      queryFn: (data) =>
        AuthorizationManager.postLogin(data).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
    otp: build.mutation<OneTimePasswordInterface, PostOptDataInterface & { headers?: IMap<string> }>({
      queryFn: ({ headers, ...data }) =>
        AuthorizationManager.postOptCode(data, headers).then((res) => {
          if (res.success) {
            return { data: res.response.data.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
  }),
});

export const { useLoginMutation, useOtpMutation } = authApiSlice;
